import { Component, computed, effect, EventEmitter, inject, input, OnDestroy, Output, TemplateRef } from '@angular/core';
import { take } from 'rxjs';

import { showAnimation } from 'src/app/infrastructure/animations/show-animation';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { ButtonActionComponent } from 'src/app/features/shared/controls/container/button-action/button-action.component';
import { DialogService } from 'src/app/features/shared/dialogs/dialog.service';
import { _CentralPageService } from '../../../services/_central-page.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { CLAIM_PAGE } from 'src/app/infrastructure/injection-tokens/PAGE-NAME';
import { loadKey } from 'src/app/infrastructure/services/loading-services/models/loadKey';

@Component({
    selector: 'app-button-block-details-section',
    templateUrl: './button-block-details-section.component.html',
    styleUrls: ['./button-block-details-section.component.scss'],
    standalone: true,
    imports: [
        SharedModule,
        ButtonActionComponent,
    ],
    animations: [
        showAnimation,
    ]
})
export class ButtonBlockDetailsSectionComponent
    implements OnDestroy
{
    private readonly __centralPageService = injectRequired(_CentralPageService);
    private readonly __dialogService = injectRequired(DialogService);

    readonly loadKey = loadKey;

    btnDeleteData$$ = this.__centralPageService.btnDeleteData$$;
    btnEditData$$ = this.__centralPageService.btnEditData$$;

    input_templateExtraButtons$$ = input<TemplateRef<any> | null>(null, {alias: 'templateExtraButtons'});
    input_lockOnLoad$$ = input<boolean>(true, {alias: 'lockOnLoad'});

    btnDeleteShow$$ = computed(() => !this.btnDeleteData$$().hide);
    btnEditShow$$ = computed(() => !this.btnEditData$$().hide);

    // Sneltoets-hint toegevoegd aan de bestaande tooltip-tekst — zelfde patroon voor alle
    // vier standaardknoppen (zie ook button-block-edit-section.component.ts).
    btnDeleteTooltip$$ = computed(() => `${this.btnDeleteData$$().tooltip || 'delete'} [Ctrl+Delete]`);
    btnEditTooltip$$ = computed(() => `${this.btnEditData$$().tooltip || 'edit'} [Ctrl+E]`);

    @Output('onBtnDelete') onClickDelete = new EventEmitter();
    @Output('onBtnEdit') onClickEdit = new EventEmitter();

    emit_btnEdit() {
        this.onClickEdit.emit();
    }

    emit_btnDelete() {
        // Vraag eerst om bevestiging; pas verwijderen na een expliciete keuze.
        this.__dialogService
            .showChoice<boolean>(
                [
                    { label: 'Verwijderen', value: true },
                    { label: 'Annuleren', value: false },
                ],
                'Weet je zeker dat je dit wilt verwijderen?',
            )
            .pipe(take(1))
            .subscribe(confirmed => {
                if (confirmed === true) this.onClickDelete.emit();
            });
    }

    ngOnDestroy(): void {
        this.onClickDelete?.unsubscribe();
        this.onClickEdit?.unsubscribe();
    }
}
